import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Loader from "../components/Loader";
import Header from "../components/Header";
import {
  SITENAMEALIAS,
  SITENAME,
  LOGO,
  CAPTCHASITEKEY,
  DEMOBROKER,
} from "../utils/init";
import { showToast, showHttpError } from "../utils/library";
import { MerchantForgotPassword } from "../utils/service";
import PaybitoCaptcha from "../components/PaybitoCaptcha";
import logo from "../assets/images/paybitologo.png";
import { updateFavicon } from "../utils/favicon";
import { Helmet } from "react-helmet";

export default class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
    };

    /*** REFERENCE FOR RETRIEVING INPUT FIELDS DATA ***/
    this.emailRef = React.createRef();
    this.captchaRef = React.createRef();
  }

  componentDidMount() {
    updateFavicon();
  }

  /* 
    Method defination for sending email and password and initiate login procedure through API Call
    */
  handleForgotPassword = async (e) => {
    e.preventDefault();
    if (!this.emailRef.current.value) {
      showToast("error", "Please provide valid email address");
      return;
    }
    try {
      const { token } = await this.captchaRef.current.verify();
      this.handleCaptchaSubmit(token);
    } catch (err) {
      showToast("error", err.message || "Captcha verification failed");
    }
  };

  handleCaptchaSubmit = (captcha) => {
    this.setState({ showLoader: true });
    let payload = {
      email: this.emailRef.current.value,
      gRecaptchaResponse: captcha,
    };
    MerchantForgotPassword(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          var response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast(
              "success",
              "An email will be sent to your registered email address."
            );
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  render() {
    const cardContent = (
      <div className="card form-card" style={{ borderRadius: "10px" }}>
        <div className="card-body cardBody">
          <h4 className="card-title text-center login-title">Reset Password</h4>
          <p className="login-hint-text" style={{ textAlign: "center" }}>
            Enter your email address that you used to register. We'll send you
            an email with your username and a link to reset your password.
          </p>
          <form
            className="forms-sample"
            onSubmit={(e) => {
              this.handleForgotPassword(e);
            }}
          >
            <div className="login-float-group">
              <input
                type="email"
                id="forgotEmail"
                ref={this.emailRef}
                placeholder=" "
              />
              <label htmlFor="forgotEmail">Email Address</label>
            </div>
            <button type="submit" className="login-btn">
              Reset My Password
            </button>
          </form>
          <PaybitoCaptcha ref={this.captchaRef} sitekey={CAPTCHASITEKEY} />
          <div className="login-links d-flex justify-content-center">
            <span>
              <Link to="/">Back To Sign In</Link>
            </span>
          </div>
        </div>
      </div>
    );

    return (
      <Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{localStorage.getItem(SITENAMEALIAS + "_exchange")}</title>
        </Helmet>
        <nav
          className="navbar navbar-light extNavbar"
          style={{
            backgroundColor: localStorage.getItem(
              SITENAMEALIAS + "_navbarColour"
            ),
          }}
        >
          <div className="image-container">
            <img
              src={localStorage.getItem(SITENAMEALIAS + "_exchangeLogo")}
              className="logo-cred "
            />
          </div>
        </nav>

        {localStorage.getItem(SITENAMEALIAS + "_isBackgroundImage") == "0" ? (
          <div
            className="login-wrapper"
            style={{
              background: localStorage.getItem(
                SITENAMEALIAS + "_backgroundColour"
              ),
            }}
          >
            <br />
            <br />
            <br />
            <br />
            <br />
            <div className="login-background">
              <div className="row mb-3">
                <div className="col-12 text-center"></div>
              </div>
              <div className="row mb-2">
                <div className="col-12 col-sm-12 col-xs-12">{cardContent}</div>
              </div>
            </div>
            {window.location.origin == DEMOBROKER ? (
              <div className="d-flex align-items-end flex-column bd-highlight mb-3 footer-data">
                <a href="https://www.paybito.com/">
                  <div className="btn btn-light mt-auto p-2 bd-highlight footer-data-text">
                    <img
                      src={logo}
                      alt=""
                      style={{ marginRight: 3, height: "30px" }}
                    />
                    Powered by PayBito infrastructure
                  </div>
                </a>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        ) : (
          <div
            className="login-wrapper"
            style={{
              backgroundImage: `url(${localStorage.getItem(
                SITENAMEALIAS + "_backgroundImageLink"
              )})`,
              backgroundRepeat: `no-repeat`,
              backgroundSize: `cover`,
              backgroundPosition: `center`,
              minHeight: `100%`,
            }}
          >
            <br />
            <br />
            <br />
            <br />
            <br />
            <div className="login-background">
              <div className="row mb-3">
                <div className="col-12 text-center"></div>
              </div>
              <div className="row mb-2">
                <div className="col-12 col-sm-12 col-xs-12">{cardContent}</div>
              </div>
            </div>
            {window.location.origin == DEMOBROKER ? (
              <div className="d-flex align-items-end flex-column bd-highlight mb-3 footer-data">
                <a href="https://www.paybito.com/">
                  <div className="btn btn-light mt-auto p-2 bd-highlight footer-data-text">
                    <img
                      src={logo}
                      alt=""
                      style={{ marginRight: 3, height: "30px" }}
                    />
                    Powered by PayBito infrastructure
                  </div>
                </a>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        )}

        <Loader show={this.state.showLoader} />
      </Fragment>
    );
  }

  componentWillMount() {}
}
